import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import Img from 'gatsby-image'
import css from '@emotion/css'
import { colors } from '../../../styles/variables'

interface Props {
  style?: React.CSSProperties
  imgStyle?: React.CSSProperties
}

export default function EducationPhoto({ style, imgStyle }: Props) {
  const data = useStaticQuery(graphql`
    query {
      desktop: file(relativePath: { eq: "images/issue-education.jpg" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  return <Img fluid={data.desktop.childImageSharp.fluid} style={{ ...style }} imgStyle={{ ...imgStyle }} alt="Justin Jones speaking." />
}
